









































































































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/movement/movementApi';
import {
  選択状態区分型,
  検索対象ソート区分型,
} from '@/type/movement/item';
import moment from 'moment';
import {商品区分一覧, 商品区分型} from '@/type/movement/types/商品区分型';
import {並び順区分一覧, 並び順区分型} from '@/type/movement/types/並び順区分型';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import {progress} from '@/script/progress';
import {to選択移動在庫商品型, 移動入力型, 選択移動在庫商品型} from '@/type/movement/records/register/部署間移動入力';
import {移動在庫商品型, 移動在庫商品検索依頼型} from '@/type/movement/records/register/移動商品検索';
import 移動商品検索条件入力チェッカー from '@/type/movement/records/register/移動商品検索条件入力チェッカー';

@Component({
  components: {
    NormalDialog,
    AmountField,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date == null) {
        return null;
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class ProductSearchModal extends Vue {
  // data
  検索条件: 移動在庫商品検索依頼型 = {...this.デフォルトの検索条件};
  検索結果: 選択移動在庫商品型[] = [];

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  次の行番号: number | null = null;
  グリッド最終行: number | null = null;
  グリッド件数: number | null = null;

  選択された検索結果行: 選択移動在庫商品型[] = [];

  beforeOpened: boolean = false;

  @Prop()
  selectedDepartmentCode!: string;

  beforeOpen() {
    const 商品名カナ入力欄 = document.getElementById('商品名カナ');
    if (商品名カナ入力欄) {
      商品名カナ入力欄.focus();
    }
    this.beforeOpened = true;
    this.選択された検索結果行 = [];
  }

  @Watch('検索結果.JANコード', {deep: true})
  数量にフォーカス(): void {
    this.$nextTick(() => {
      this.グリッド件数 = this.検索結果.length;
      if (this.beforeOpened === true && this.グリッド件数 > 0) {
        this.入力欄を指定().箱数入力欄[0].$el.childNodes[0].focus();
        this.行を選択する(0);
      }
    });
  }

  @Emit('confirmed')
  confirmed(): 移動入力型[] {
    return this.選択されている検索結果行.map((record) => record.移動入力);
  }

  // computed
  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get 商品区分一覧(): 商品区分型[] {
    return 商品区分一覧;
  }

  get デフォルトの検索条件(): 移動在庫商品検索依頼型 {
    return {
      部署コード: null,
      検索対象商品区分: null,
      検索対象ソート区分: '商品名',
      メーカー名検索文字列: null,
      商品名カナ検索文字列: null,
    };
  }

  get 選択されている検索結果行(): 選択移動在庫商品型[] {
    // 保存された行から、画面で選択を外された明細を除外
    const 選択された検索結果全行 =
      this.選択された検索結果行.filter((選択行) =>
          this.検索結果.filter((検索結果行) =>
              検索結果行.移動入力.商品コード === 選択行.移動入力.商品コード &&
              検索結果行.移動入力.有効期限 === 選択行.移動入力.有効期限 &&
              検索結果行.選択状態区分 !== 選択状態区分型.対象).length === 0);
    // 画面の選択行を反映
    this.検索結果.filter((value) => value.選択状態区分 === 選択状態区分型.対象).forEach((選択行) => {
      const 検索結果行 = 選択された検索結果全行.find((value) => value.移動入力.商品コード === 選択行.移動入力.商品コード &&
                                                             value.移動入力.有効期限 === 選択行.移動入力.有効期限);
      if (検索結果行) {
        検索結果行.選択状態区分 = 選択行.選択状態区分;
        検索結果行.移動入力.箱数 = 選択行.移動入力.箱数;
        検索結果行.移動入力.バラ数 = 選択行.移動入力.バラ数;
        検索結果行.移動入力.箱数バラ換算 = 選択行.移動入力.箱数バラ換算;
        検索結果行.移動入力.総移動数 = 選択行.移動入力.総移動数;
      } else {
        選択された検索結果全行.push(選択行);
      }
    });
    return 選択された検索結果全行;
  }

  検索開始に移動するハンドラ(keyCode: number, repeat: boolean) {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    const 検索開始ボタン = document.getElementById('検索開始');
    if (!検索開始ボタン) return;
    検索開始ボタン.focus();
  }

  // methods
  検索確認する(): void {
    // ※現在、別検索で選択保持化に伴い、直接「検索する」が呼び出されるようになっている
    if (this.検索結果.some((it) => it.選択状態区分 === 選択状態区分型.対象)) {
      this.$modal.show('商品追加選択中確認ダイアログ');
      return;
    }
    this.検索する();
  }

  商品追加選択中確認ダイアログを閉じる(): void {
    this.$modal.hide('商品追加選択中確認ダイアログ');
  }

  async 検索する(): Promise<void> {
    this.$modal.hide('商品追加選択中確認ダイアログ');
    const checker = new 移動商品検索条件入力チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    const 検索処理 = async (): Promise<void> => {
      this.選択された検索結果行 = this.選択されている検索結果行;
      this.検索結果 = [];
      this.検索条件.部署コード = this.selectedDepartmentCode;
      await api.移動在庫商品一覧を取得する(this.検索条件)
        .then((response: any) => {
          const 商品: 移動在庫商品型[] = response.移動在庫商品検索結果一覧;
          this.検索結果 = 商品.map((record) => to選択移動在庫商品型(record));
          this.検索結果.forEach((検索結果行) => {
            const 選択行 = this.選択された検索結果行.find((value) => value.移動入力.商品コード === 検索結果行.移動入力.商品コード &&
                                                                   value.移動入力.有効期限 === 検索結果行.移動入力.有効期限);
            if (選択行) {
              検索結果行.選択状態区分 = 選択行.選択状態区分;
              検索結果行.移動入力.箱数 = 選択行.移動入力.箱数;
              検索結果行.移動入力.バラ数 = 選択行.移動入力.バラ数;
              検索結果行.移動入力.箱数バラ換算 = 選択行.移動入力.箱数バラ換算;
              検索結果行.移動入力.総移動数 = 選択行.移動入力.総移動数;
            }
          });
          if (this.検索結果.length === 0) {
            this.showAlert('検索結果が0件です。');
            return;
          }
          if (response.アラートメッセージ) {
            this.showAlert(response.アラートメッセージ);
          }
        }).catch((error: any) => {
          this.showAlert(error.data.message);
        });
    };
    await progress(検索処理);
  }

  検索条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.検索条件入力エラー判定(項目名)};
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 移動商品検索条件入力チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  並び順区分一覧を取得(): 並び順区分型[] {
    return 並び順区分一覧;
  }

  全解除する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択状態区分 = 選択状態区分型.対象外;
    }
    this.$forceUpdate();
  }

  全選択する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択状態区分 = 選択状態区分型.対象;
    }
    this.$forceUpdate();
  }

  確定する(): void {
    if (this.選択されている検索結果行.length === 0) {
      this.showAlert('商品が選択されていません');
      return;
    }

    this.confirmed();
    this.clear();
    this.close();
  }

  中止する(): void {
    this.clear();
    this.close();
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('移動商品追加アラート');
  }

  clear(): void {
    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果 = [];
    this.アラートメッセージ = null;
  }

  close(): void {
    this.beforeOpened = false;
    this.$modal.hide('部署間移動商品追加画面');
  }

  入力欄を指定(): any {
    return this.$refs;
  }

  箱数量からフォーカス移動(行番号: number, keyCode: number, repeat: boolean): void {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    if (this.バラ管理である) {
      this.入力欄を指定().バラ数入力欄[行番号].$el.childNodes[0].focus();
    } else {
      this.次の行番号 = 行番号 + 1;
      this.グリッド最終行 = (this.表示件数) - 1;
      if (this.グリッド最終行 >= this.次の行番号) {
        this.入力欄を指定().箱数入力欄[this.次の行番号].$el.childNodes[0].focus();
        this.行を選択する(this.次の行番号);
      } else {
        this.入力欄を指定().箱数入力欄[行番号].$el.childNodes[0].blur();
      }
    }
    this.箱数量フォーカス移動時選択チェック(行番号);
  }

  バラ数量からフォーカス移動(行番号: number, keyCode: number, repeat: boolean): void {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    this.次の行番号 = 行番号 + 1;
    this.グリッド最終行 = (this.表示件数) - 1;
    if (this.グリッド最終行 >= this.次の行番号) {
      this.入力欄を指定().箱数入力欄[this.次の行番号].$el.childNodes[0].focus();
      this.行を選択する(this.次の行番号);
    } else {
      this.入力欄を指定().バラ数入力欄[行番号].$el.childNodes[0].blur();
    }
    this.バラ数量フォーカス移動時選択チェック(行番号);
  }

  箱数量フォーカス移動時選択チェック(行番号: number): void {
    if (this.検索結果[行番号].移動入力.箱数 > 0) {
      this.検索結果[行番号].選択状態区分 = 選択状態区分型.対象;
    } else {
      this.検索結果[行番号].選択状態区分 = 選択状態区分型.対象外;
    }
  }

  バラ数量フォーカス移動時選択チェック(行番号: number): void {
    if (this.検索結果[行番号].移動入力.箱数 > 0) return;
    if (this.検索結果[行番号].移動入力.バラ数 > 0) {
      this.検索結果[行番号].選択状態区分 = 選択状態区分型.対象;
    } else {
      this.検索結果[行番号].選択状態区分 = 選択状態区分型.対象外;
    }
  }

  移動後在庫数チェック(行番号: number): void {
    if (this.バラ管理である) {
      return this.バラ管理の移動後在庫数計算処理(行番号);
    } else {
      return this.箱管理の移動後在庫数計算処理(行番号);
    }
  }

  箱管理の移動後在庫数計算処理(行番号: number): void {
    this.検索結果[行番号].移動入力.総移動数 = this.検索結果[行番号].移動入力.箱数;
    this.検索結果[行番号].移動入力.移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  バラ管理の移動後在庫数計算処理(行番号: number): void {
    this.検索結果[行番号].移動入力.箱数バラ換算 = this.箱数をバラ数に換算する(行番号);
    this.検索結果[行番号].移動入力.総移動数 = this.移動するバラ数を合計する(行番号);
    this.検索結果[行番号].移動入力.移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  箱数をバラ数に換算する(行番号: number): any {
    if (this.検索結果[行番号].移動入力.包装単位数 === null || this.検索結果[行番号].移動入力.包装単位数 === 0) {
      return 0;
    }
    if (this.検索結果[行番号].移動入力.バラ単位区分 === '包装単位')　{
      return this.検索結果[行番号].移動入力.箱数 * this.検索結果[行番号].移動入力.入数;
    } else {
      return this.検索結果[行番号].移動入力.箱数 * (this.検索結果[行番号].移動入力.入数　/ this.検索結果[行番号].移動入力.包装単位数);
    }
  }

  移動するバラ数を合計する(行番号: number): any {
    return this.検索結果[行番号].移動入力.箱数バラ換算 + this.検索結果[行番号].移動入力.バラ数;
  }

  移動後の在庫数を計算する(行番号: number): any {
    return Math.round((this.検索結果[行番号].移動入力.現在庫数 - this.検索結果[行番号].移動入力.総移動数) * 1000) / 1000;
  }
}
